/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AptosActivityListInfo } from '../models/AptosActivityListInfo';
import type { AptosActivityListRequest } from '../models/AptosActivityListRequest';
import type { AptosAddressNftListInfo } from '../models/AptosAddressNftListInfo';
import type { AptosAddressNftListRequest } from '../models/AptosAddressNftListRequest';
import type { AptosAnalyticsChartInfo } from '../models/AptosAnalyticsChartInfo';
import type { AptosCollectionActivityListRequest } from '../models/AptosCollectionActivityListRequest';
import type { AptosCollectionAnalysisRequest } from '../models/AptosCollectionAnalysisRequest';
import type { AptosCollectionDetailInfo } from '../models/AptosCollectionDetailInfo';
import type { AptosCollectionDetailRequest } from '../models/AptosCollectionDetailRequest';
import type { AptosCollectionListInfo } from '../models/AptosCollectionListInfo';
import type { AptosCollectionListRequest } from '../models/AptosCollectionListRequest';
import type { AptosCollectionTransactionListRequest } from '../models/AptosCollectionTransactionListRequest';
import type { AptosHighlightCollectionInfo } from '../models/AptosHighlightCollectionInfo';
import type { AptosHolderListInfo } from '../models/AptosHolderListInfo';
import type { AptosHolderRequest } from '../models/AptosHolderRequest';
import type { AptosMarketplaceFlagInfo } from '../models/AptosMarketplaceFlagInfo';
import type { AptosMarketplaceInfo } from '../models/AptosMarketplaceInfo';
import type { AptosMarketPlaceListRequest } from '../models/AptosMarketPlaceListRequest';
import type { AptosMetadataUpdateRequest } from '../models/AptosMetadataUpdateRequest';
import type { AptosTokenActionListInfo } from '../models/AptosTokenActionListInfo';
import type { AptosTokenActivityListRequest } from '../models/AptosTokenActivityListRequest';
import type { AptosTokenDetailInfo } from '../models/AptosTokenDetailInfo';
import type { AptosTokenDetailRequest } from '../models/AptosTokenDetailRequest';
import type { AptosTokenListInfo } from '../models/AptosTokenListInfo';
import type { AptosTokenListRequest } from '../models/AptosTokenListRequest';
import type { AptosTokenMetaDataDetailInfo } from '../models/AptosTokenMetaDataDetailInfo';
import type { AptosTokenMetaDataRequest } from '../models/AptosTokenMetaDataRequest';
import type { AptosTokenTransactionListRequest } from '../models/AptosTokenTransactionListRequest';
import type { AptosTrxListInfo } from '../models/AptosTrxListInfo';
import type { CommonEmptyRequest } from '../models/CommonEmptyRequest';
import type { EvmNftActivityListInfo } from '../models/EvmNftActivityListInfo';
import type { EvmNftActivityRequest } from '../models/EvmNftActivityRequest';
import type { EvmNftMintListInfo } from '../models/EvmNftMintListInfo';
import type { EvmNftResult } from '../models/EvmNftResult';
import type { EvmNftTransferListInfo } from '../models/EvmNftTransferListInfo';
import type { EvmNftTransferRequest } from '../models/EvmNftTransferRequest';
import type { NftResult } from '../models/NftResult';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class NftControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTransferList({
        requestBody,
    }: {
        requestBody: EvmNftTransferRequest,
    }): CancelablePromise<EvmNftTransferListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/nft/transfer/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getNftTradeList({
        requestBody,
    }: {
        requestBody: EvmNftActivityRequest,
    }): CancelablePromise<EvmNftActivityListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/nft/trade/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTokenMetadataUpdate({
        requestBody,
    }: {
        requestBody: AptosMetadataUpdateRequest,
    }): CancelablePromise<NftResult> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/nft/token/metadata/update',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTokenActionList({
        requestBody,
    }: {
        requestBody: CommonEmptyRequest,
    }): CancelablePromise<AptosTokenActionListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/nft/token/action/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getMintList({
        requestBody,
    }: {
        requestBody: EvmNftActivityRequest,
    }): CancelablePromise<EvmNftMintListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/nft/mint/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getCollectionMarketplaceList({
        requestBody,
    }: {
        requestBody: AptosMarketPlaceListRequest,
    }): CancelablePromise<AptosMarketplaceFlagInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/nft/marketplace/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getCollectionMarketplaceCategoryList({
        requestBody,
    }: {
        requestBody: CommonEmptyRequest,
    }): CancelablePromise<Array<AptosMarketplaceInfo>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/nft/marketplace/category/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getCollectionTokenList({
        requestBody,
    }: {
        requestBody: AptosCollectionTransactionListRequest,
    }): CancelablePromise<AptosTrxListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/nft/collection/transaction/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getCollectionTokenTransactionList({
        requestBody,
    }: {
        requestBody: AptosTokenTransactionListRequest,
    }): CancelablePromise<AptosTrxListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/nft/collection/token/transaction/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTokenMetadata({
        requestBody,
    }: {
        requestBody: AptosTokenMetaDataRequest,
    }): CancelablePromise<AptosTokenMetaDataDetailInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/nft/collection/token/metadata',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTokenList1({
        requestBody,
    }: {
        requestBody: AptosTokenListRequest,
    }): CancelablePromise<AptosTokenListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/nft/collection/token/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getCollectionTokenHolderList({
        requestBody,
    }: {
        requestBody: AptosHolderRequest,
    }): CancelablePromise<AptosHolderListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/nft/collection/token/holder/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getCollectionTokenDetail({
        requestBody,
    }: {
        requestBody: AptosTokenDetailRequest,
    }): CancelablePromise<AptosTokenDetailInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/nft/collection/token/detail',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getCollectionActivityList({
        requestBody,
    }: {
        requestBody: AptosTokenActivityListRequest,
    }): CancelablePromise<AptosActivityListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/nft/collection/token/activity/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getCollectionList({
        requestBody,
    }: {
        requestBody: AptosCollectionListRequest,
    }): CancelablePromise<AptosCollectionListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/nft/collection/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getCollectionHolderList({
        requestBody,
    }: {
        requestBody: AptosHolderRequest,
    }): CancelablePromise<AptosHolderListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/nft/collection/holder/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getHighlightCollection({
        requestBody,
    }: {
        requestBody: CommonEmptyRequest,
    }): CancelablePromise<AptosHighlightCollectionInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/nft/collection/highlight',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getCollectionDetail({
        requestBody,
    }: {
        requestBody: AptosCollectionDetailRequest,
    }): CancelablePromise<AptosCollectionDetailInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/nft/collection/detail',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getCollectionAnalysis({
        requestBody,
    }: {
        requestBody: AptosCollectionAnalysisRequest,
    }): CancelablePromise<AptosAnalyticsChartInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/nft/collection/analysis',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTokenActivityList({
        requestBody,
    }: {
        requestBody: AptosCollectionActivityListRequest,
    }): CancelablePromise<AptosActivityListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/nft/collection/activity/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getCardList({
        requestBody,
    }: {
        requestBody: CommonEmptyRequest,
    }): CancelablePromise<EvmNftResult> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/nft/card/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getAddressList({
        requestBody,
    }: {
        requestBody: AptosAddressNftListRequest,
    }): CancelablePromise<AptosAddressNftListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/nft/address/nft/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getActivityList({
        requestBody,
    }: {
        requestBody: (AptosActivityListRequest | EvmNftActivityRequest),
    }): CancelablePromise<(AptosActivityListInfo | EvmNftActivityListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/nft/activity/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
